import React, { createContext, useState, useEffect, useContext } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const getInitialLanguage = () => {
        return localStorage.getItem("selectedLanguage") || "Tigrigna";
    };

    const [selectedLanguage, setSelectedLanguage] = useState(getInitialLanguage);

    useEffect(() => {
        localStorage.setItem("selectedLanguage", selectedLanguage);
    }, [selectedLanguage]);

    const languageOptions = [
        { name: "English", code: "en" },
        { name: "Amharic", code: "am" },
        { name: "Tigrigna", code: "ti" },
        { name: "Afan Oromo", code: "om" },
    ];

    const translations = {
        English: {
            // HERO / GENERAL
            title: "Your Tech & Engineering Hub",
            line_1: "🚀  Build high-performance digital platforms designed for maximum business growth.",
            line_2: "⚡ Provide electric safety and energy management solutions, backed by 10+ years of utility experience, to protect your equipment and significantly cut your bills.",
            line_3: "📊 Turn your business data into clear, strategic insights for better decisions.",
			cta: "👉 Contact US",

            // NAVIGATION
            nav_home: "🏠 Home",
            nav_services: "🛠️ Services",
            nav_contact: "📞 Contact",
            nav_download: "📥 Download",
            nav_login_signup: "🧑 Login/Signup",

            // SERVICES
            sub_web_dev: "🌐 Web Development",
            sub_app_dev: "📱 Mobile APP Development",
            sub_data_analysis: "📊 Data Analysis Dashboard",
            sub_tutorial: "🎓 Tutorials",
            sub_electrical: "⚡ Electrical Consultancy",

            // CONTACT
            contact_title: "📞 Contact Us",
            contact_name: "Your Name",
            contact_phone: "Your Phone Number",
            contact_email: "Your Email",
            contact_subject: "Select Subject",
            contact_message: "Your Message",
            contact_send: "Send",

            subject_vacancy: "Vacancy",
            subject_website: "Website",
            subject_webapp: "Web App",
            subject_mobileapp: "Mobile App",
            subject_software: "Software",
            subject_dashboard: "Data Analysis Dashboard",
            subject_consultancy: "Consultancy",
            subject_other: "Other",

            // LOGIN
            login_title: "Login",
            login_email: "Email",
            login_password: "Password",
            login_button: "Login",
            login_no_account: "Don't have an account?",
            login_register_here: "Register here",
            login_failed: "Login failed. Please check your credentials.",

            // REGISTER
            register_title: "Register",
            register_username: "Username",
            register_email: "Email",
            register_password: "Password",
            register_button: "Register",
            register_have_account: "Already have an account?",
            register_login_here: "Login here",
            register_failed: "Error registering user.",
            

        },

        Amharic: {
            // HERO
            title: "የቴክኖሎጂና ምህንድስና ማዕከልዎ",
            line_1: "🚀  ንግድዎን/ሥራዎን ለማሳደግ እና የተሻለ ለመምራት የሚያግዙ ዲጂታል መተግበሪያ እንገነባለን።",
            line_2: "⚡ ከ10+ ዓመታት  በኢትዮጵያ ኤሌክትሪክ አገልግሎት የገነባነው ልምድ ጋር በማጣመር በኤሌክትሪክ ውድ ንብረትዎን እንዳይበላሽ እና አላስፈላጊ የኤሌክትሪክ ክፍያ ለማስቀረት የማማከር አገልግሎት፡፡.",
            line_3: "📊 የስራዎን አጠቃላይ ሪፖርት ውሳኔ ለመስጠት በሚያመች መልኩ ማዘጋጀት ፡፡  ",
            cta: "👉 ፕሮጀክትዎን ይጀምሩ",

            // NAVIGATION
            nav_home: "🏠 መነሻ",
            nav_services: "🛠️ አገልግሎቶች",
            nav_contact: "📞 እውቂያ",
            nav_download: "📥 አውርድ",
            nav_login_signup: "🧑 ይግቡ/ይመዝገቡ",

            // SERVICES
            sub_web_dev: "🌐 ድረ-ገጽ ልማት",
            sub_app_dev: "📱 ሞባይል መተግበሪያ ልማት",
            sub_data_analysis: "📊 ዳታ ትንተና ዳሽቦርድ",
            sub_tutorial: "🎓 ትምህርቶች",
            sub_electrical: "⚡ ኤሌክትሪክ አማካሪነት",

            // CONTACT
            contact_title: "📞 ያግኙን",
            contact_name: "ስምዎ",
            contact_phone: "ስልክ ቁጥርዎ",
            contact_email: "ኢሜይልዎ",
            contact_subject: "ርዕስ ይምረጡ",
            contact_message: "መልእክትዎ",
            contact_send: "ላክ",

            subject_vacancy: "ስራ",
            subject_website: "ድረ-ገጽ",
            subject_webapp: "ኮምፒተር  መተግበሪያ",
            subject_mobileapp: "ሞባይል መተግበሪያ",
            subject_software: "ሶፍትዌር",
            subject_dashboard: "ዳታ ትንተና ዳሽቦርድ",
            subject_consultancy: "የኤሌክትሪክ ምክር አገልግሎት",
            subject_other: "ሌላ",

            // LOGIN
            login_title: "ግባ",
            login_email: "ኢሜይል",
            login_password: "የይለፍ ቃል",
            login_button: "ግባ",
            login_no_account: "አካውንት የለዎትም?",
            login_register_here: "እዚህ ይመዝገቡ",
            login_failed: "መግባት አልተሳካም። እባክዎን ዝርዝሮችዎን ይከተሉ።",

            // REGISTER
            register_title: "ይመዝገቡ",
            register_username: "የተጠቃሚ ስም",
            register_email: "ኢሜይል",
            register_password: "የይለፍ ቃል",
            register_button: "ይመዝገቡ",
            register_have_account: "አካውንት አለዎት?",
            register_login_here: "እዚህ ይግቡ",
            register_failed: "ተጠቃሚ ማመዝገብ አልተሳካም።",
        },

        Tigrigna: {
            // HERO
            title: "ማእከል ቴክኖሎጂን ምህንድስናን ",
            line_1: "🚀  ንግድኹም/ስራሕኹም  ንምዕባይን ንዝበለፀ ምምራሕን ዝሕግዝ መተግበሪ ንሰርሕ ፡፡።",
            line_2: "⚡ ልዕሊ 10 ዓመታት  አብ ግልጋሎት ኤሌክትሪክ ኢትዮጵያ  ዝረከብናዮ  ልምዲ  ብምጥማር   ብኤሌክትሪክ  ንብረቶም  ንከይበላሸን ኣድላይ ዘይኮነ ናይ ኤሌክትሪክ ክፍሊት ንምትራፍን   ግልጋሎት ምምኻር፡፡.",
            line_3: "📊 ናይ ስርሖም ዳታ/ፀብፃብ ንምግምጋምን ውሳኔ ንምሃብን ብዝምቹ መልክዕ ብዘመናዊ መንግዲ ዳሽቦርድ ንሰርሕ  ፡፡  ",
            cta: "👉 ተወከሱና",

            // NAVIGATION
            nav_home: "🏠 መበገሲ",
            nav_services: "🛠️ ኣገልግሎታት",
            nav_contact: "📞 አድራሽ",
            nav_download: "📥 ኣውርድ",
            nav_login_signup: "🧑 እቶ/ተመዝገብ",

            // SERVICES
            sub_web_dev: "🌐 ድረ-ገጽ ልምዓት",
			sub_app_dev: "📱ናይ  ኮምፒተር መተግበሪ ",
            sub_app_dev: "📱 📱ናይ  ሞባይል  መተግበሪ ",
            sub_data_analysis: "📊 ዳታ ትንተና",
            sub_tutorial: "🎓 ትምህርቲ",
            sub_electrical: "⚡ ኤሌክትሪክ ምኽሪ",

            // CONTACT
            contact_title: "📞 ርኸቡና",
            contact_name: "ሽምኩም",
            contact_phone: "ቁጽሪ ተሌፎን",
            contact_email: "ኢሜይል",
            contact_subject: "ርእሲ ምረጹ",
            contact_message: "መልእኽቲኩም",
            contact_send: "ስደድ",

            subject_vacancy: "ስራሕ",
            subject_website: "ድረ-ገጽ",
            subject_webapp: "ናይ ኮምፒተር መተግበሪ",
            subject_mobileapp: "ናይ ሞባይል መተግበሪ",
            /*subject_software: "ሶፍትው",*/
            subject_dashboard: "ዳታ/ፀብፃብ ትንተና ዳሽቦርድ",
            subject_consultancy: "ግልጋሎት ሞያ ናይ ኤሌክትሪክ  ",
            subject_other: "ካልእ",

            // LOGIN
            login_title: "እተው",
            login_email: "ኢሜይል",
            login_password: "ናይ ምሽጥር ቁልፊ",
            login_button: "እተው",
            login_no_account: "አካውንት የብልኩምን/ክንን?",
            login_register_here: "ኣብዚ ብምንካእ ይመዝገቡ/ባ",
            login_failed: "አይተሳከዐን። ብትትክክል ይምልኡ/ኣ።",

            // REGISTER
            register_title: "ይመዝገቡ/ባ",
            register_username: "ሽም ",
            register_email: "ኢሜይል",
            register_password: "ናይ ምሽጥር ቁልፊ",
            register_button: "መዝግብ",
            register_have_account: "ኣካውንት ኣለኩም/ክን?",
            register_login_here: "ኣብዚ ብምንካእ ይእተዉ",
            register_failed: "ምዝገባ ኣይተሳከዐን።",
        },

        "Afan Oromo": {
            // HERO
            title: "Wiirtuu Teknooloojii fi Injinariingii",
            line_1: "🚀 Sagalee dhiibbaa guddaa qaban kan guddina daldalaatiif dizaayinii ta'an ijaari.",
            line_2: "⚡ Fayyummaa elektiriikii fi furmaata bulchiinsa anniisaa, kan waggoota 10+ muuxannoo tajaajilaatiin deeggarame, meeshaalee keessan eeguufii fi baasiiwwan keessan hir’isuuf gumaacha.",
            line_3: "📊 Odeeffannoo daldala keessanii gara hubannoo haala-qilleessaatti, murtoo gaarii argachuuf jijjiiri.",
            cta: "👉 Projeektii Keessan Jalqabaa",

            // NAVIGATION
            nav_home: "🏠 Fuula Duraa",
            nav_services: "🛠️ Tajaajila",
            nav_contact: "📞 Quunnamtii",
            nav_download: "📥 Buufadhu",
            nav_login_signup: "🧑 Seenuu/Galmeessuu",

            // SERVICES
            sub_web_dev: "🌐 Guddina Weebii",
            sub_app_dev: "📱 Guddina Moobaayilaa",
            sub_data_analysis: "📊 Xiinxala Daataa",
            sub_tutorial: "🎓 Leenjii",
            sub_electrical: "⚡ Maree Elektirikii",

            // CONTACT
            contact_title: "📞 Nu Qunnamaa",
            contact_name: "Maqaa Kee",
            contact_phone: "Lakkoofsa Bilbila Kee",
            contact_email: "Email Kee",
            contact_subject: "Mataduree Filadhu",
            contact_message: "Ergaa Kee",
            contact_send: "Ergi",

            subject_vacancy: "Teessoo Hojii",
            subject_website: "Website",
            subject_webapp: "Web App",
            subject_mobileapp: "Mobile App",
            subject_software: "Software",
            subject_dashboard: "Data Dashboard",
            subject_consultancy: "Gorsa",
            subject_other: "Kan biroo",

            // LOGIN
            login_title: "Seeni",
            login_email: "Email",
            login_password: "Password",
            login_button: "Seeni",
            login_no_account: "Akaawuntii hin qabduu?",
            login_register_here: "Asitti galmaa'i",
            login_failed: "Seensii hin milkaa'in. Odeeffannoo mirkaneessi.",

            // REGISTER
            register_title: "Galmaa'i",
            register_username: "Maqaa Fayyaa",
            register_email: "Email",
            register_password: "Password",
            register_button: "Galmaa'i",
            register_have_account: "Akaawuntii qabduu?",
            register_login_here: "Asitti seeni",
            register_failed: "Galmeen fayyadamtoota hin milkaa'in.",
        },
    };

    return (
        <LanguageContext.Provider
            value={{
                selectedLanguage,
                setSelectedLanguage,
                languageOptions,
                t: translations[selectedLanguage] || translations.English,
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);